import { createAjv } from "@jsonforms/core";

export const codeGroupMultipleFileDonwloadJsonSchema = {
  type: "object",
  properties: {
    fileName: {
      type: "string",
      title: "File name (case-sensitive)",
    },
    codeGroupId: {
      type: "string",
      title: "Code Group ID",
    },
    createdBy: {
      type: "string",
      title: "Created By",
    },
    notificationEmailAddress: {
      type: "string",
      title: "Notification Email Address",
    },
    folders: {
      type: "array",
      items: {
        type: "object",
        properties: {
          folder: { type: "string", title: "Folder Name" },
          numOfCodes: { type: "integer", title: "Number of Codes" },
          numOfFiles: { type: "integer", title: "Number of Files" },
        },
        required: ["folder", "numOfCodes", "numOfFiles"],
      },
    },
  },
  required: [
    "fileName",
    "codeGroupId",
    "createdBy",
    "notificationEmailAddress",
    "folders",
  ],
};

export const codeGroupMultipleFileDonwloadUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "VerticalLayout",
      label: "File Name",
      elements: [
        {
          type: "Control",
          scope: "#/properties/fileName",
          label: "File name (case-sensitive)",
        },
      ],
    },
    {
      type: "VerticalLayout",
      label: "Folder Setup",
      elements: [
        {
          type: "Control",
          scope: "#/properties/folders",
          component: "customArray",
          options: {
            detail: {
              type: "HorizontalLayout",
              elements: [
                {
                  type: "Control",
                  scope: "#/properties/folder",
                  label: "Folder Name",
                },
                {
                  type: "Control",
                  scope: "#/properties/numOfCodes",
                  label: "Number of Codes",
                },
                {
                  type: "Control",
                  scope: "#/properties/numOfFiles",
                  label: "Number of Files",
                },
              ],
            },
          },
        },
      ],
    },
  ],
};

// Helpers for Code Group Multi File Download modal
export const isMultiFileFormIncomplete = (formData) => {
  const name = formData?.fileName;
  if (!name || (typeof name === "string" && name.trim() === "")) return true;

  const folders = formData?.folders;
  if (!Array.isArray(folders) || folders.length === 0) return true;

  return folders.some((f) => {
    if (!f) return true;
    const folderName = f.folder;
    const hasFolder =
      !!folderName && (typeof folderName !== "string" || folderName.trim() !== "");
    const hasNumOfCodes = f.numOfCodes !== undefined && f.numOfCodes !== null;
    const hasNumOfFiles = f.numOfFiles !== undefined && f.numOfFiles !== null;
    return !(hasFolder && hasNumOfCodes && hasNumOfFiles);
  });
};

export const extraValidateMultiFile = (formData) => {
  const name = formData?.fileName;
  const namePattern = /^[A-Za-z0-9-_ ]+$/;
  if (!name || (typeof name === "string" && name.trim() === "")) {
    return { valid: false, message: "Folder Label is required." };
  }
  if (typeof name === "string" && !namePattern.test(name)) {
    return {
      valid: false,
      message: "Folder Label must be alphanumeric or contain -,_ only.",
    };
  }

  const folders = formData?.folders;
  if (!Array.isArray(folders) || folders.length === 0) {
    return { valid: false, message: "At least one folder is required." };
  }

  const seen = new Set();
  for (let i = 0; i < folders.length; i++) {
    const f = folders[i];
    if (!f) return { valid: false, message: `Folder #${i + 1} is incomplete.` };
    const folderName = f.folder;
    if (
      !folderName ||
      (typeof folderName === "string" && folderName.trim() === "")
    ) {
      return {
        valid: false,
        message: `File Name is required for folder #${i + 1}.`,
      };
    }
    if (seen.has(folderName)) {
      return { valid: false, message: "Duplicate Folder Labels are not allowed." };
    }
    seen.add(folderName);

    const numOfCodes = Number(f.numOfCodes);
    if (!Number.isFinite(numOfCodes)) {
      return {
        valid: false,
        message: `No. of Codes must be numeric for folder #${i + 1}.`,
      };
    }
    if (!(numOfCodes > 0)) {
      return {
        valid: false,
        message: `No. of Codes must be greater than 0 for folder #${i + 1}.`,
      };
    }
    // if (!(numOfCodes < Number(codesCount))) {
    //   return {
    //     valid: false,
    //     message: `No. of Codes must be less than total codes (${codesCount}) for folder #${i + 1}.`,
    //   };
    // }

    const numOfFiles = Number(f.numOfFiles);
    if (!Number.isFinite(numOfFiles)) {
      return {
        valid: false,
        message: `No. of Files must be numeric for folder #${i + 1}.`,
      };
    }
    if (!(numOfFiles > 0)) {
      return {
        valid: false,
        message: `No. of Files must be greater than 0 for folder #${i + 1}.`,
      };
    }
    const maxCodes = numOfFiles * 1000000000;
    if (!(numOfCodes <= maxCodes)) {
      return {
        valid: false,
        message: `No. of Codes must be less than or equal to ${maxCodes} for folder #${i + 1}.`,
      };
    }
  }
  return { valid: true };
};

export const validateMultiFileSchema = (payload) => {
  const ajv = createAjv();
  const validate = ajv.compile(codeGroupMultipleFileDonwloadJsonSchema);
  const valid = validate(payload);
  return { valid, errors: validate.errors };
};
